var _style, _defs, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "plus-circle_svg__Icon_-_Add",
    x: 0,
    y: 0,
    viewBox: "0 0 11 11"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".plus-circle_svg__st1{fill:none;stroke:#57d33b;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "plus-circle_svg__SVGID_1_",
    d: "M.2.2h10.5v10.5H.2z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "plus-circle_svg__SVGID_00000167382597304606066120000014011899254120786109_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#plus-circle_svg__SVGID_1_",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus-circle_svg__Group_1513",
    clipPath: "url(#plus-circle_svg__SVGID_00000167382597304606066120000014011899254120786109_)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "plus-circle_svg__Ellipse_240",
    cx: 5.5,
    cy: 5.5,
    r: 4.5,
    className: "plus-circle_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plus-circle_svg__Line_553",
    d: "M5.5 7.8V3.2",
    className: "plus-circle_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plus-circle_svg__Line_554",
    d: "M3.2 5.5h4.6",
    className: "plus-circle_svg__st1"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBpZD0iSWNvbl8tX0FkZCIgeD0iMCIgeT0iMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTEgMTEiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDExIDExIj48c3R5bGU+LnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiM1N2QzM2I7c3Ryb2tlLXdpZHRoOjEuNTtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmR9PC9zdHlsZT48ZGVmcz48cGF0aCBpZD0iU1ZHSURfMV8iIGQ9Ik0uMi4yaDEwLjV2MTAuNUguMnoiLz48L2RlZnM+PGNsaXBQYXRoIGlkPSJTVkdJRF8wMDAwMDE2NzM4MjU5NzMwNDYwNjA2NjEyMDAwMDAxNDAxMTg5OTI1NDEyMDc4NjEwOV8iPjx1c2UgeGxpbms6aHJlZj0iI1NWR0lEXzFfIiBzdHlsZT0ib3ZlcmZsb3c6dmlzaWJsZSIvPjwvY2xpcFBhdGg+PGcgaWQ9Ikdyb3VwXzE1MTMiIHN0eWxlPSJjbGlwLXBhdGg6dXJsKCNTVkdJRF8wMDAwMDE2NzM4MjU5NzMwNDYwNjA2NjEyMDAwMDAxNDAxMTg5OTI1NDEyMDc4NjEwOV8pIj48Y2lyY2xlIGlkPSJFbGxpcHNlXzI0MCIgY3g9IjUuNSIgY3k9IjUuNSIgcj0iNC41IiBjbGFzcz0ic3QxIi8+PHBhdGggaWQ9IkxpbmVfNTUzIiBkPSJNNS41IDcuOFYzLjIiIGNsYXNzPSJzdDEiLz48cGF0aCBpZD0iTGluZV81NTQiIGQ9Ik0zLjIgNS41aDQuNiIgY2xhc3M9InN0MSIvPjwvZz48L3N2Zz4=";
export { SvgPlusCircle as ReactComponent };